<div class="container-tarjeta">
    <div class="nombre">
        <h3 class="text-h3">Hola, soy <span class="text-xl text-lg text-md text-sm text-color-nombre">Brayan Taday</span></h3>
    </div>
    <div class="redes container-fluid">
        <div class="row">
            <div class="col">
                <a href="https://github.com/Bryan-Taday" target="_blank"><i class="fab fa-github"></i></a>
            </div>
            <div class="col">
                <a href="https://www.instagram.com/brayan___taday" target="_blank"><i class="fab fa-instagram"></i></a>
            </div>
            <div class="col">
                <a href="https://www.facebook.com/Brayan.Taday.98" target="_blank"><i class="fab fa-facebook"></i></a>
            </div>
            <div class="col">
                <a href="https://twitter.com/Brayan___Taday" target="_blank"><i class="fab fa-twitter"></i></a>
            </div>
        </div>
    </div>
</div>